module.exports = __webpack_public_path__ + "img/sleeve_length.a17c2ebe.png";